module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_11_B-straciles-3-zycia.7a658409.mp3";